export default __webpack_public_path__ + "static/pragicts-partnerships-banner-itops-27e31cc6ffb3db47c213ef850ea4cb17.jpg";